
import { Vue, Component, Model, Prop } from 'nuxt-property-decorator';
import InputText from './InputText.vue';

@Component({
  components: {
    InputText,
  },
})
export default class InputTextPassword extends Vue {
  @Prop({ type: String, required: true }) readonly name!: string;
  @Prop({ type: String, default: '' }) readonly label!: string;
  @Prop({ type: String, default: '' }) readonly help!: string;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: Boolean, default: false }) readonly hideRequiredMark!: boolean;
  @Model('input', { type: [String, Number], default: null }) readonly value!: string | number | null;
  @Prop({ type: [String, Object], default: null }) readonly validation!: object | string | null;

  password = '';
  showPassword = false;

  get inputLabel() {
    return this.label || this.$t('shared.inputs.password.label');
  }

  get iconName() {
    return this.showPassword ? 'eye-off' : 'eye';
  }
}
